// extracted by mini-css-extract-plugin
export default {"tag":"lsf-tag","tag_size_small":"lsf-tag_size_small","tag_size_compact":"lsf-tag_size_compact","waiting":"lsf-waiting"};